import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { CardLink, CardLinksData } from './components';
import LocalStorageService from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  container: {
    display: 'flex',
    flexDirection: 'row',       // toujours en ligne
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
    padding: '50px 16px',
  }
}));

export const Home = () => {
  const classes = useStyles();
  const {t} = useTranslation("common");

  const authState = useSelector((state) => state.auth);
  const localUser = LocalStorageService.getUser();

  const currentUser = {
    ...localUser,
    offers: authState?.data?.offers || localUser.offers || []
  };

  const offerAvailableFilter = (item) => {
    if (currentUser?.roles && currentUser.roles[0] === "ROLE_STUDENT_PARTNER") {
      const offers = Array.isArray(currentUser.offers) ? currentUser.offers : [];
      return offers.includes(item);
    }
    return true;
  };

  const getCardFilter = () => {
    let listCard = [];
    CardLinksData.map((cardLink) => {
      if (offerAvailableFilter(cardLink.value)) {
        switch (cardLink.text) {
          case 't("app.health-mobility-card")':
            cardLink = { ...cardLink, text: t("app.health-mobility-card"), describe: t("app.health-mobility-card-description"), startingFrom: t("app.health-mobility-card-starting-from") };
            break;
          case 't("app.home-card")':
            cardLink = { ...cardLink, text: t("app.home-card"), describe: t("app.home-card-description"), startingFrom: t("app.home-card-starting-from") };
            break;
          case 't("app.multimedia-card")':
            cardLink = { ...cardLink, text: t("app.multimedia-card")};
            break;
          case 't("app.health-mutual-card")':
            cardLink = { ...cardLink, text: t("app.health-mutual-card"), describe: t("app.health-mutual-card-description"), startingFrom: t("app.health-mutual-card-starting-from") };
            break;
          case 't("app.rc-card")':
            cardLink = { ...cardLink, text: t("app.rc-card"), describe: t("app.rc-card-description"), startingFrom: t("app.rc-card-starting-from") };
            break;
          default:
            break;
        }
        listCard.push(cardLink);
      }
    });
    return listCard;
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4} className={classes.container}>
        {getCardFilter().map((card) => (
          <CardLink
            text={card.text}
            describe={card.describe}
            startingFrom={card.startingFrom}
            image={card.image}
            link={card.link}
            color={card.color}
            icon={card.icon}
            displayForCS={card.displayForCS}
            key={card.link}
            newO={card.newO}
          />
        ))}
      </Grid>
    </div>
  );
};
